var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "summaryBox"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._m(0), _c('div', {
    staticClass: "summaryTime"
  }, [_c('span', {
    staticClass: "titleName"
  }, [_vm._v("Summary Time:")]), _c('span', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.summaryTime))])])]), _c('el-divider'), _c('div', {
    staticClass: "summaryContent scrollbar"
  }, _vm._l(_vm.summaryDate, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "summaryLi"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "name titleName"
    }, [_vm._v(_vm._s(item.nickName))]), _c('span', {
      staticClass: "time grayColor"
    }, [_vm._v(_vm._s(_vm.retrunTime(item)))])]), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])]);
  }), 0)], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "partyName"
  }, [_c('span', {
    staticClass: "titleName"
  }, [_vm._v("Party Name:")]), _c('span', {
    staticClass: "white"
  }, [_vm._v("Common party / TVU Internal Discussion")])]);
}];
export { render, staticRenderFns };